/**
 * Proxy for react-360 dependencies required by the client package
 */

// Client set up dependencies
import {Location, Module, ReactInstance} from 'react-360-web';

// React-360 camera controllers and raycasters extended for custom implementations
import CameraController from 'react-360-web/js/Controls/CameraControllers/Types';
import MousePanCameraController from 'react-360-web/js/Controls/CameraControllers/MousePanCameraController';
import ScrollPanCameraController from 'react-360-web/js/Controls/CameraControllers/ScrollPanCameraController';
import MouseRaycaster from 'react-360-web/js/Controls/Raycasters/MouseRaycaster';
import TouchRaycaster from 'react-360-web/js/Controls/Raycasters/TouchRaycaster';

// React-360 input channels for custom implementations
import MouseInputChannel from 'react-360-web/js/Controls/InputChannels/MouseInputChannel';
import TouchInputChannel from 'react-360-web/js/Controls/InputChannels/TouchInputChannel';
import KeyboardInputChannel from 'react-360-web/js/Controls/InputChannels/KeyboardInputChannel';
import GamepadInputChannel from 'react-360-web/js/Controls/InputChannels/GamepadInputChannel';

// Required by the client for type definitions
import Quaternion from 'react-360-web/js/Controls/Types';
import Vec3 from 'react-360-web/js/Controls/Types';
import {Euler, Quaternion as ThreeJsQuaternion, Vector3} from 'three';
import {ButtonEvent, InputEvent, InputChannel} from 'react-360-web/js/Controls/InputChannels/Types';

module.exports = {
    Location,
    Module,
    ReactInstance,
    CameraController,
    MousePanCameraController,
    ScrollPanCameraController,
    MouseRaycaster,
    TouchRaycaster,
    MouseInputChannel,
    TouchInputChannel,
    KeyboardInputChannel,
    GamepadInputChannel,
    InputChannel,
    ButtonEvent,
    InputEvent,
    Vec3,
    Quaternion,
    Euler,
    ThreeJsQuaternion,
    Vector3
};
